<template>
  <div>
    <div id="banner">
      <div class="slider-pro sp-horizontal" id="example1" style="width: 100%; max-width: 5200px">
        <div class="sp-slides">
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15002842221.jpg"
                alt=""
                title="" /></a>
          </div>
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15011452161.png"
                alt=""
                title=""/></a>
          </div>
        </div>
      </div>
    </div>
    <div id="wrap_c">
      <div class="breadCrumb">
        <a href="/" tabindex="101" class="breadCrumb_no" title="首頁">首頁</a>
        <router-link :to="{name:'公司簡介'}"><span>關於白金</span></router-link>
        <router-link :to="{name:'核心競爭力'}"><span>核心競爭力</span></router-link>
      </div>

      <h2 class="titleA">核心競爭力</h2>
      <div id="page_left">
        <div id="menu_out">
          <div id="menu_c">
            <ul class="m_top"></ul>
            <li>
              <router-link :to="{name:'公司簡介'}" class="menu_on0">關於白金</router-link>
              <span
                style="cursor: hand"
                class="arrow_class_close"
                onclick="allshow_show_menu2(this,'2279','http://www.ptotinc.com/','0','','2280')">
                <img
                  src="~@/assets/folder_close.png"
                  id="img_son_menu_2279"
                  class="class_sonimg_0"/>
              </span>
            </li>
            <div id="son_menu_2279" class="class_sondiv_0" style="display: ">
              <ol>
                <router-link :to="{name:'公司簡介'}" class="menu_on0">公司簡介</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'經營理念'}" class="menu_on0">經營理念</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'核心競爭力'}" class="menu_on2">核心競爭力</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'企業沿革'}" class="menu_on0">企業沿革</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'企業社會責任'}" class="menu_on0">企業社會責任</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'產業新聞'}" class="menu_on0">產業新聞</router-link>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div id="page_right_no">
        <!--###右側欄區塊###-->
      </div>

      <div id="page_main_2">
        <!--###內頁中間內容區塊###-->
        <div class="cC">
          <form
            method="POST"
            action="portal_c2_cnt.php?owner_num=c2_38424&amp;button_num=c2&amp;folder_id=2280&amp;search_type=1"
          >
            <div class="searchbar">
              <ul>
                <li>
                  尋找：

                  <select tabindex="62" name="search_field">
                    <option value="all_field">全部</option>
                    <option value="text_field_0">標題</option>
                  </select>
                  <input
                    tabindex="63"
                    name="search_word"
                    type="text"
                    class="input"
                    value=""
                  />
                  <input
                    tabindex="64"
                    name="search_b1"
                    type="submit"
                    class="btn"
                    value="查詢"
                  />
                  <!--<input name="Submit3" type="button" class="btn2" value="進階查詢" onclick="location.href='http://www.ptotinc.com/member/ptotinc/portal_c2_cnt.php?owner_num=c2_38424&button_num=c2&folder_id=2280&search_type=2';"/>-->
                </li>
              </ul>
            </div>
          </form>

<div class="cate_info">     <span style="font-size: 15px;"><strong><span style="font-size: 18px;">核心競爭力</span></strong></span>
<div style="text-align: center;"><span style="font-size: 15px;"><span style="font-size: 15px;"><span style="font-size: 18px;"><strong><img alt="" src="~@/assets/Competitive.png" style="width: 700px; height: 700px;"></strong></span></span></span></div>
<br>
<br>
<span style="font-size: 15px;"><span style="font-size: 15px;">白金科技股份有限公司的使命<br>
<br>
使數位影像呈現地球自然的顏色<br>
&nbsp;<br>
人類相信自石器時代即已使用天然的火山玻璃，古埃及在公元前二千年左右已有記載使用玻璃作器皿，西元前 200 年，巴比倫發明了玻璃吹管製玻璃的方法，接著這個方法傳入羅馬，歐洲在公元一世紀左右羅馬的波特蘭瓶即是玻璃浮雕作品。<br>
1827 年發明的玻璃壓印機器，開展了大規模生產廉價玻璃器具的道路。<br>
&nbsp;<br>
中國在西周時亦已開始製造玻璃。在西周時期的古墓中曾發現玻璃管、玻璃珠等物品。南北朝以前，中文多以琉璃稱，以火燒成玻璃質透明物。<br>
&nbsp;<br>
公元前四百多年，中國的《墨經》一書就詳細記載了光的直線前進、光的反射， 以及平面鏡、凹面鏡、凸面鏡的成像現象。到了宋代，在沈括所著的《夢溪筆談》（ 1031 至 1095 年）一書中，還詳細敘述了“小孔成像匣”的原理。<br>
&nbsp;<br>
在 15 世紀 , 哥白尼教士便曾指出：假如肉眼銳利的話，可以看得見金星也跟月亮一樣有盈虧。<br>
&nbsp;<br>
100 年後的西元 1608 年，有一位荷蘭的光學家，無意之中將兩張玻璃片組合起來，竟能將遠處的景物，看得好像就在眼前一樣。立刻吸引了伽利略的注意。根據他的推想，於是成功的製造了望遠鏡直接影響了人類天文學的發展，但是也幾乎為他惹來殺身之禍。<br>
&nbsp;<br>
1884 年，近代光學玻璃材料工廠在德國成立，光學鏡片正式進入大量生產的時代，嘉惠你我。<br>
&nbsp;<br>
2007 年，白金科技股份有限公司設立了台灣第一條全製程光學玻璃材料工廠，勇敢的踏入歷史的洪流，結合數位影像，使數位影像呈現地球自然的顏色。</span></span> </div>
          <ul id="c_list"></ul>

          <br /><br />
          <p style="text-align: center"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'competitive',
  // mixins: [sliderPro],
  data () {
    return {
      msg: 'Competitive'
    }
  },
  created: function () {
    console.log('created')
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    // sliderPro.m1()
    // sliderProAddTitle('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@')
    // sliderPro.initialSliderPro()
    // sliderPro.m1('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@')
  },
  methods: {
    init: function () {
      $('#rwd_nav').pageslide({
          modal: true
      });
      $('.sp-selected .sp-font span').addClass('animated fadeInLeft');
      $('.sp-selected .sp-font2').addClass('animated fadeInRight');
      $('#example1').sliderPro({
          keyboardOnlyOnFocus: true,
          set_swipe: '1',
          width: '5120',
          height: '1280',
          autoplay: true,
          waitForLayers: true,
          autoScaleLayers: false,
          fade: true,
          autoplayDelay: 5000,
          arrows: false,
          buttons: false,
          breakpoints: {
            1024: {
              forceSize: '',
              width: '1024',
              height: '256'
            }
          }
      });
      sliderPro_add_title('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@');
      initVideo();
    }
  }
}
</script>
<style src='@/assets/css/15347449502.css'>
</style>


// WEBPACK FOOTER //
// src/components/about/Competitive.vue